
import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator';
import DateTimePicker from '@/components/DateTimePicker.vue';
import Util from '@/utils/util';
import zipcode from '@/zipcode.json';

interface address{
  city: string,
  districts: [],
}

@Component({
  components: { DateTimePicker },
})
export default class ScheduledMessageForm extends Vue {
  @Prop({}) private msgFrom!: string;

  @Prop({}) private msgBody!: string;

  @Prop({}) private msgLink!: string;

  @Prop({ default: false }) private isEnabled!: boolean;

  @Prop({}) private addressFilter!: Array<address>;

  @Prop({}) private sendTime!: string;

  @Prop({ default: false }) private loading!: boolean;

  @Prop({ default: false }) private readOnly!: boolean;

  private valid: boolean = false;

  private maxRegionFilterCount: number = 5;

  private zc: any = zipcode;

  private form = {
    msgFrom: this.msgFrom,
    msgBody: this.msgBody,
    msgLink: this.msgLink,
    isEnabled: this.isEnabled,
    addressFilter: this.addressFilter,
    sendTime: this.sendTime,
  };

  private spLinks = [
    'sp://from/',
    'sp://from/web/usage/commodity',
    'sp://from/web/usage/point',
    'sp://from/web/exchange',
    'sp://from/web/exchange/swap-in',
  ];

  private rules = {
    msgFrom: [this.requiredRule('推播來源')],
    msgBody: [this.requiredRule('推播內容')],
    enable: [this.requiredRule('啟用停用')],
    date: [this.requiredRule('推播日期')],
    city: [this.requiredRule('縣市')],
    district: [this.requiredRule('區')],
  };

  private get inputs() {
    return {
      msgFrom: this.msgFrom,
      msgBody: this.msgBody,
      msgLink: this.msgLink,
      isEnabled: this.isEnabled,
      addressFilter: this.addressFilter || [],
      sendTime: this.sendTime,
    };
  }

  @Watch('inputs', { immediate: true })
  private inputsWatcher(val: any) {
    this.form = {
      ...val,
    };
  }

  private showAddFilter() {
    return this.form.addressFilter.length < this.maxRegionFilterCount;
  }

  private requiredRule(column: string) {
    return (v: any) => !Util.isNullOrEmpty(v) || `${column} 為必填`;
  }

  private maxLengthRule(column: string, length: number) {
    return (v: any) => !v || v?.length <= length || `${column} 最多 ${length} 字`;
  }

  private getCities(currentCity: string) {
    let selectedCities = this.form.addressFilter.map((p: address) => p.city);
    if (currentCity) {
      selectedCities = selectedCities.filter((city) => city !== currentCity);
    }
    const cities = Object.keys(this.zc).filter((p) => !selectedCities.includes(p));
    return cities;
  }

  private getDistricts(city: any) {
    return Object.keys(this.zc[city] || {});
  }

  private addRegionFilter() {
    if (this.form.addressFilter.length < this.maxRegionFilterCount) {
      this.form.addressFilter.push({ city: '', districts: [] });
    }
  }

  private removeFilter(index: number) {
    this.form.addressFilter.splice(index, 1);
  }

  private async cancel() {
    await this.$router.back();
  }

  @Emit()
  private async submit() {
    const form = this.$refs.form as any as { validate: () => boolean };
    if (form.validate()) {
      return this.form;
    }
    return null;
  }
}
